import { Skeleton, Stack } from "@mui/material";

const PaymentCardSkeleton = ({ compact = false }) => (
  <Stack spacing={1.5} sx={{ p: compact ? 1.5 : 2 }}>
    <Stack direction="row" justifyContent="space-between" alignItems="center">
      <Skeleton variant="text" width="45%" height={28} />
      <Skeleton variant="rounded" width={88} height={32} />
    </Stack>
    <Stack direction="row" spacing={1}>
      <Skeleton variant="rounded" width={120} height={28} />
      <Skeleton variant="rounded" width={96} height={28} />
    </Stack>
    <Skeleton variant="text" width="70%" />
    <Skeleton variant="rounded" height={compact ? 40 : 48} />
  </Stack>
);

export default PaymentCardSkeleton;
